import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { methodSteps } from '../../data/method';
export function Method() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-159" data-mp="2ao7lnam48r2j">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-160" data-mp="26nnlrza5r9cp">
        <SectionTag icon="🎯" data-id="element-161" data-mp="26nfaucxlie45">El método "Sesión en Mano"</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-162" data-mp="21pm1jb0zx3zn">
          El Método "Sesión en Mano"
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-163" data-mp="1rqetn3d161jx">
          Preparar tu próximo entrenamiento puede ser así de sencillo:
        </p>
      </div>

      <div className="mx-auto mt-8 flex max-w-4xl flex-col gap-4 px-4 sm:flex-row sm:items-stretch sm:gap-3 sm:px-6" data-id="element-164" data-mp="1nqmhyhscbfac">
        {methodSteps.map((step, i) => <React.Fragment key={step.n} data-id="element-165" data-mp="3i3vt0e0jb8up" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-white/10 bg-bg-primary p-6 text-center" data-id="element-166" data-mp="3i0q2cuc9bywv">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-lime/10" data-id="element-167" data-mp="32klpbghjfgj3">
                <step.icon size={22} className="text-lime" data-id="element-168" data-mp="3qa69u3tcaluh" />
              </div>
              <p className="mt-3 font-heading text-lg font-bold uppercase tracking-wide text-white" data-id="element-169" data-mp="3v8rbm7o8pdl1">
                {step.n}. {step.title}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-170" data-mp="3heql217fywvr">{step.text}</p>
            </m.div>
            {i < methodSteps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-lime/40 sm:block" aria-hidden="true" data-id="element-171" data-mp="d2cww6i5czll" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-2xl px-4 text-center text-sm leading-relaxed text-muted sm:px-6 sm:text-base" data-id="element-172" data-mp="rmz6rpf5rlns">
        Sin pasarte horas buscando en YouTube. Sin juntar ejercicios aleatorios que no tienen hilo
        conductor. Sin llegar al campo preguntándote qué vas a hacer cuando los jugadores ya están en
        círculo mirándote.
      </p>
    </section>;
}